import axios from 'axios'
// const BASE_URL = "//dev.zhuangxiu.com/api.php?s="; // 这是正式的
var BASE_URL = "https://contact.audi.cn/contact/dealers"; // 这是正式的
if (process.env.NODE_ENV == 'development') {
    BASE_URL = "http://127.0.0.1:9080/contact/dealers"; 
}
// create an axios instance
const service = axios.create({
    baseURL: BASE_URL, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        // if (store.getters.token) {
        //     // let each request carry token
        //     // ['X-Token'] is a custom headers key
        //     // please modify it according to the actual situation
        //     //config.headers['token'] = getToken()
        // }
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // // if the custom code is not 20000, it is judged as an error.
        // if (res.code !== 200) {
        //     console.error(res);
        //    // alert(res.msg);
        //     // Message({
        //     //     message: res.msg || 'Error',
        //     //     type: 'error',
        //     //     duration: 5 * 1000
        //     // })

        //     // // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        //     // if (res.code === 1000) {
        //     //     store.dispatch('user/resetToken').then(() => {
        //     //         location.reload()
        //     //     })
        //     // }
        //     return Promise.reject(new Error(res.msg || 'Error'))
        // } else {
        //     return res
        // }
        return res;
    },
    error => {
        console.error(error);
        // console.log('err' + error) // for debug
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        return Promise.reject(error)
    }
)

export default service;

export function get(url, params) {
    return new Promise((resolve, reject) => {
        service({ url: url, method: 'get', params }).then(res => {
            resolve(res);
        }).catch(e => {
            reject();
        })
    });
}


export function post(url, data) {
    return new Promise((resolve, reject) => {
        service({ url: url, method: 'post', data }).then(res => {
            resolve(res);
        }).catch(e => {
            reject(e);
        })
    });
}

export function upload(url, data) {
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            resolve(res);
        }).catch(e => {
            reject(e);
        })
    });
}
